import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgPinboard = function SvgPinboard(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M22.283 5.314l-3.637-3.637a1.5 1.5 0 00-2.326.256L13.226 7.4a7.63 7.63 0 00-1.766-.2 6.32 6.32 0 00-3.513.755 1.5 1.5 0 00-.3 2.355l6.008 6.009c.335.32.793.475 1.252.427a1.5 1.5 0 001.1-.729 6.783 6.783 0 00.548-5.278l5.472-3.099a1.5 1.5 0 00.256-2.326zM8.071 14.559l-6.5 6.5a1 1 0 000 1.414c.394.382 1.02.382 1.414 0l6.5-6.5a1 1 0 00-1.414-1.414z"
  }));
};

export default SvgPinboard;